import { useCallback, useEffect } from 'react';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useAppDispatch, useAppSelector } from '../app/app-hooks';
import {
  fetchProgramDocuments,
  selectProgramDocumentsEntry,
} from '../features/api/slices/program-documents-slice';
import { useNewClientApi } from '../features/api/use-client-api';

export const useProgramDocuments = (programId: string) => {
  const api = useNewClientApi();
  const dispatch = useAppDispatch();
  const { selectedLocale } = useLocale();
  const entry = useAppSelector((state) =>
    selectProgramDocumentsEntry(state, programId, selectedLocale),
  );
  const refresh = useCallback(
    () =>
      dispatch(
        fetchProgramDocuments({ api, programId, locale: selectedLocale }),
      ).unwrap(),
    [api, dispatch, programId, selectedLocale],
  );

  useEffect(() => {
    if (!programId) return;
    // SliceRequest owns user-facing errors; consume the rejected promise here.
    void refresh().catch(() => undefined);
  }, [programId, refresh]);

  return { ...entry, refresh };
};
